module.exports = __webpack_public_path__ + "static/img/reece-scruggs-head@2x.7ea2c51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/reece-scruggs-head@2x.png
// module id = gCnJ
// module chunks = 13